(function() {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ParCorporateCurvePointOpen', ParCorporateCurvePointOpen);

    ParCorporateCurvePointOpen.$inject = ['$resource', 'DateUtils'];

    function ParCorporateCurvePointOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/par-corporate-curve-points/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
